/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const HeroFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  Hero: gql`
    fragment HeroQuery on homeHero_Entry {
      productPickerTable {
        ... on productPickerCategories_Category {
          productPickerCtaLabel
          productPickerTable {
            state
            courseType
            productName
            productLink
            ctaOverride
            noFollow
            noReferrer
            modal
          }
        }
      }
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      buttonListStyle
      buttonList {
        ... on buttonListBlock_Entry {
          buttonIcon {
            url
            ... on images_Asset {
              altText
            }
          }
          buttonLink
          buttonLinkNewTab
          buttonLinkNofollow
          buttonSubtitle
          buttonTitle
          buttonCtaTag
        }
      }
      heroContent
      heroImage {
        url
        ... on images_Asset {
          altText
          width
          height
        }
      }
      heroTitle
      imageAlignment
      lineBreak_content
      lineBreak_styles
      showImageOnMobile
      showTrustpilot
      styles
      typeHandle
      videoButton {
        ... on videoButtonBlock_Entry {
          ctaLabel
          wistiaId
        }
      }
    }
  `,
};
